<template>
    <card-tile title="Program" :min-height="270">
        <h3 class="mb-3 mx-auto">
            {{ program.name }}
        </h3>
        <v-avatar size="120">
            <router-link
                :to="{
                    name: 'Program Edit',
                    params: {
                        id: program.id,
                    },
                }"
            >
                <img :src="program.icon_filepath" />
            </router-link>
        </v-avatar>
        <v-tooltip top color="secondary">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class="ml-4"
                    :to="{
                        name: 'Program Edit',
                        params: {
                            id: program.id,
                        },
                    }"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon>mdi-folder-edit</v-icon> Edit</v-btn
                >
            </template>
            <span>Edit Program</span>
        </v-tooltip>
    </card-tile>
</template>

<script>
export default {
    name: "program-card",
    components: {
        CardTile: () =>
            import("@/components/program/components/Dashboard/CardTile.vue"),
    },
    props: {
        program: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
</style>